import Routes from './routes'
import ReactDOM from 'react-dom'
import '../../scss/application.scss'

ReactDOM.render(Routes, document.getElementById('root'))
